import { render, staticRenderFns } from "./SettingsPlugin.vue?vue&type=template&id=4c086e89&scoped=true&"
import script from "./SettingsPlugin.vue?vue&type=script&lang=js&"
export * from "./SettingsPlugin.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPlugin.vue?vue&type=style&index=0&id=4c086e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c086e89",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/SettingsPlugin.vue
// module id = null
// module chunks = 